import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bfa0c198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Activate")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Deactivate")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_6 = ["onSubmit"]
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Payment Method", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 0,
  class: "form-field"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Billing Day", -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Default day is set to 1", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Activating")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Deactivating")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Autopay ")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Activate")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Deactivate")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Autopay ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_23 = { style: {"color":"red"} }

import { ref } from "vue";
import { useRouter } from "vue-router";
import api from "@virgodev/bazaar/functions/api";
import Payment from "@/components/Payment.vue";
import BaseAlert from "@/components/BaseAlert.vue";
import { useStore } from "@/store";
import { storeToRefs } from "pinia";
import { paymentAccountInterface } from "@/types/customers";


export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: [Number, String],
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
  accountId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

const router = useRouter();
const formSubmitting = ref(false);
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
// api_name is nullable on the Facility model (a facility can be saved with no
// API assigned), and the serializer returns null for it. Unguarded, this threw
// during setup and left the whole page blank — for a label only CC Storage shows.
const providerName = (userData.value.chosenFacility.api_name || "").replace(
  /_/g,
  " "
);
const errors = ref("");
const rental = ref();
const paymentAccounts = ref();

const formFields = ref({
  ledger_id: props.accountId,
  autopay: {
    autopay_enabled: ref(),
    autopay_day: ref(1),
  },
  payment_method: {
    payment_method_id: ref(),
  },
});
const foundAccount = ref();
async function getLedgers() {
  errors.value = "";
  const response = await api({
    url: `ledgers/?only_ids=${props.accountId}&include_as_object=events&facilityId=${props.facilityId}&customer_id=${props.customerId}`,
  });
  if (response.status == 200) {
    if (response.body.ledgers) {
      rental.value = response.body.ledgers[0];
    } else {
      rental.value = response.body[0];
    }
    let payment_method_id = "";
    if (api_settings.use_autopay_in_rental) {
      if (rental.value.autopay) {
        payment_method_id = rental.value.autopay;
      }
    } else {
      payment_method_id = rental.value.autopay_info.payment_method_id;
    }
    if (rental.value.autopay_enabled || rental.value.autopay) {
      formFields.value.payment_method.payment_method_id = payment_method_id;
      formFields.value.autopay.autopay_enabled = false;
    } else {
      formFields.value.autopay.autopay_enabled = true;
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
    if (api_settings.filter_payment_accounts) {
      let account = paymentAccounts.value.filter(
        (item: { id: string }) => item.id == props.accountId.toString()
      );
      if (account.length > 0) {
        if (account[0].autopay) {
          foundAccount.value = account[0];
        }
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
function addPaymentMethod(e: paymentAccountInterface) {
  formFields.value.payment_method = e.payment_method;
}
async function submitForm() {
  formSubmitting.value = true;
  if (!formFields.value.autopay.autopay_day) {
    formFields.value.autopay.autopay_day = 1;
  }
  const json = JSON.parse(JSON.stringify(formFields.value));

  errors.value = "";
  const response = await api({
    url: `ledgers_autopay/?id=${props.accountId}&facilityId=${props.facilityId}`,
    method: "PUT",
    json,
  });
  if (response.status == 200) {
    router.push({
      name: "payment_details_storedge",
      params: {
        customerId: props.customerId,
        customerName: props.customerName,
        facilityId: props.facilityId,
      },
    });
  } else if (response.status == 400) {
    errors.value = response.body.error;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  formSubmitting.value = false;
}
getLedgers();
getPaymentAccounts();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (rental.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: {
          name: 'payment_details_storedge',
          params: {
            customerId: __props.customerId,
            customerName: __props.customerName,
            facilityId: __props.facilityId,
          },
        }
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("h1", null, [
            (_unref(api_settings).allow_autopay_changes)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (formFields.value.autopay.autopay_enabled)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_3
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _hoisted_4
                      ], 64))
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" Autopay for Unit " + _toDisplayString(rental.value.unit.name), 1)
          ]),
          (!_unref(api_settings).allow_autopay_changes)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(BaseAlert, { variant: "info" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Autopay cannot be changed here. Any changes to this customer's autopay enrollment or settings must be made directly in " + _toDisplayString(_unref(providerName)) + ". ", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_RouterLink, {
                  class: "btn",
                  to: {
            name: 'payment_details_storedge',
            params: {
              customerId: __props.customerId,
              customerName: __props.customerName,
              facilityId: __props.facilityId,
            },
          }
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["to"])
              ], 64))
            : (_openBlock(), _createElementBlock("form", {
                key: 1,
                class: "large-width-centered",
                onSubmit: _withModifiers(submitForm, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (foundAccount.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Found account " + _toDisplayString(foundAccount.value.payment_method.card_number ||
              foundAccount.value.payment_method.account_number +
                " -  " +
                foundAccount.value.payment_method.account_type), 1))
                    : (_unref(api_settings).new_payment_method_autopay)
                      ? (_openBlock(), _createBlock(Payment, {
                          key: 1,
                          "facility-id": __props.facilityId,
                          "customer-id": __props.customerId.toString(),
                          onPaymentMethod: addPaymentMethod
                        }, null, 8, ["facility-id", "customer-id"]))
                      : _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 2,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.payment_method.payment_method_id) = $event)),
                          class: "form-select",
                          required: ""
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentAccounts.value, (method) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: method.id + 'method',
                              value: method.id
                            }, _toDisplayString(method.card_number ||
                method.account_number + " -  " + method.account_type), 9, _hoisted_10))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, formFields.value.payment_method.payment_method_id]
                        ])
                ]),
                (formFields.value.autopay.autopay_enabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.autopay.autopay_day) = $event)),
                        type: "number",
                        disabled: foundAccount.value
                      }, null, 8, _hoisted_13), [
                        [_vModelText, formFields.value.autopay.autopay_day]
                      ]),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn",
                  disabled: formSubmitting.value
                }, [
                  (formSubmitting.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (formFields.value.autopay.autopay_enabled)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_16
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_17
                            ], 64)),
                        _hoisted_18
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (formFields.value.autopay.autopay_enabled)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_19
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_20
                            ], 64)),
                        _hoisted_21
                      ], 64))
                ], 8, _hoisted_15),
                _createVNode(_component_RouterLink, {
                  class: "btn",
                  to: {
            name: 'payment_details_storedge',
            params: {
              customerId: __props.customerId,
              customerName: __props.customerName,
              facilityId: __props.facilityId,
            },
          }
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }, 8, ["to"])
              ], 40, _hoisted_6)),
          _createElementVNode("div", _hoisted_23, _toDisplayString(errors.value), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})